import type {ExportEnv} from './types'

export * from './index.browser'

/** @public */
export const environment: ExportEnv = 'react-server'
